import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styles from './JoinTheLounge.module.sass';
import { modalsActions } from '../../../modals/actions';
import MODALS from '../../../modals/constants/modals';
import { userObjectSelector } from '../../../user/selectors/user';
import Button from '../../../ui_kit/button/Button';
import ClickableDiv from '../../../ui_kit/clickable_div/ClickableDiv';

function JoinTheLounge(props) {
  const { user, openSignInModal, openSignUpModal } = props;
  if (user) { return null; }

  return (
    <>
      <Button
        size="small"
        onClickHandler={openSignUpModal}
        color="yellow"
        className={styles.join}
        text="JOIN NOW"
      />
      <ClickableDiv onClick={openSignInModal} className={styles.login}>
        Already have an account? Log in here
      </ClickableDiv>
    </>
  );
}

JoinTheLounge.propTypes = {
  user: PropTypes.shape({}),
  openSignInModal: PropTypes.func.isRequired,
  openSignUpModal: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  user: userObjectSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
  openSignUpModal: () => dispatch(modalsActions.openModalRequest({
    modal: MODALS.EXTENDED_SIGN_UP,
  })),
  openSignInModal: () => dispatch(modalsActions.openModalRequest({
    modal: MODALS.SIGN_IN,
  })),
});

export default connect(mapStateToProps, mapDispatchToProps)(JoinTheLounge);
